/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from '@insticator/insticator-ui';


/* ++++++++++ --------------- TOOLTIPS CONFIGS - TRENDING CONFIGS : STYLES --------------- ++++++++++ */
export default {
  generalconfig: {
    
  },
};
